import Page from "webPage/Page";
import CookieHelper from "base/CookieHelper";

Page.register('single-post', () => {
    let $quizBannerPopup = $('.js-quiz-banner-popup');

    if($quizBannerPopup.length > 0){
        $(window).on('scroll', () => {
            if($quizBannerPopup.hasClass('dismissed')){
                return false;
            }
            $quizBannerPopup.removeClass('hidden');
        });
    }

    $('body').on('click', '.js-close-quiz-popup', function () {
        $quizBannerPopup.addClass('hidden dismissed');
        CookieHelper.set('dismiss-quiz-popup', 1, 30);
    });
});


